import { render, staticRenderFns } from "./AccountUpgradeModal.container.vue?vue&type=template&id=0acc0cbc&scoped=true&"
import script from "./AccountUpgradeModal.container.vue?vue&type=script&lang=ts&"
export * from "./AccountUpgradeModal.container.vue?vue&type=script&lang=ts&"
import style0 from "./AccountUpgradeModal.container.vue?vue&type=style&index=0&id=0acc0cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acc0cbc",
  null
  
)

export default component.exports